import Guid from '../guid/Guid';
import { ISpPageContext } from '../dataSources/ISpPageContext';

export class Killswitch {

    private static _killSwitches: { [key: string]: boolean };

    /**
     * Performs the static initialization of the kill switches map.
     * @param {{[key: string]: boolean}} killSwitches - The map of all active killswitches.
     */
    public static initKillSwitches(killSwitches: { [guid: string]: boolean }): void {
        Killswitch._killSwitches = killSwitches || {};
    }

    /**
     * Returns true if the given SPO killswitch is found in the static map
     * of active killswitches.
     * @requires - The application should initialize the static map
     * of active killswitches using initKillSwitches before invoking this method.
     * @param killSwitch - The string representation of the guid identifying the
     * killswitch to check.
     * @param date - The date when the kill switch check has been added to the codebase.
     * @param message - A text message associated with the kill switch.
     * @returns True if the given kill switch is found active.
     */
    public static isActivated(killSwitch: string, date?: string, message?: string): boolean {
        // use _spPageContextInfo for backward compatibility while still available
        const pageContext: ISpPageContext = (window as any)['_spPageContextInfo'];
        if (!Killswitch._killSwitches && pageContext && pageContext.killSwitches) {
            Killswitch.initKillSwitches(pageContext.killSwitches);
        }

        if (killSwitch && Killswitch._killSwitches) {
            return Killswitch._killSwitches[Guid.normalizeUpper(killSwitch, false /*includeBrackets*/)];
        } else {
            return false;
        }
    }
}

export function getKillSwitch(pageContext: Pick<ISpPageContext, 'killSwitches'>): {
    isActivated: (killSwitch: string, date?: string, message?: string) => boolean;
} {
    const killSwitches = pageContext && pageContext.killSwitches;

    return {
        isActivated: (killSwitch: string, date?: string, message?: string) => {
            return !!killSwitches && !!killSwitches[Guid.normalizeUpper(killSwitch, false /*includeBrackets*/)];
        }
    };
}
